/* Flikar under produktbilderna (område produktsida). Mobilens utfällbara rader är <details> och behöver ingen JS. */
(function () {
  function valj(root, flik) {
    root.querySelectorAll('[role="tab"]').forEach(function (f) {
      var vald = f === flik;
      f.setAttribute('aria-selected', vald ? 'true' : 'false');
      f.tabIndex = vald ? 0 : -1;
      var panel = document.getElementById(f.getAttribute('aria-controls'));
      if (panel) panel.hidden = !vald;
    });
  }

  function init(root) {
    if (root.dataset.dgProduktsidaFlikarKlar) return;
    root.dataset.dgProduktsidaFlikarKlar = '1';
    var flikar = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    flikar.forEach(function (flik, i) {
      flik.addEventListener('click', function () {
        valj(root, flik);
      });
      flik.addEventListener('keydown', function (e) {
        var steg = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!steg) return;
        e.preventDefault();
        var nasta = flikar[(i + steg + flikar.length) % flikar.length];
        valj(root, nasta);
        nasta.focus();
      });
    });
  }

  function start(scope) {
    (scope || document).querySelectorAll('[data-dg-produktsida-flikar]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start();
    });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) {
    start(e.target);
  });
})();
